import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { IP } from "../../../../../internalServer";

const StudentTableActivityCompleted = ({
  completeSLData,
  completeActivitys,
  completeActivity_id,
  entryType,
  gradeScaleId,
}) => {
  const student_id = completeSLData?.student_id?.id;
  const student = completeSLData?.student_id;
  const isCompleted = completeSLData?.status === "completed";

  // 🔥 Get obtained marks and grade from data
  const obtainedMarks = completeSLData?.obtainedMarks;
  const obtainedGrade = completeSLData?.obtainedGrade;
  const totalMarks = completeActivitys?.total_marks || 0;

  // Helper to get grade details from gradeScale
  const getGradeDetails = (grade) => {
    if (!gradeScaleId || !gradeScaleId.grades || !grade) return null;
    return gradeScaleId.grades.find((g) => g.grade === grade);
  };

  // 🔥 Render marks or grade
  const renderMarksOrGrade = () => {
    // Pending status
    if (completeSLData?.status === "pending") {
      return "--";
    }

    // If entryType is "Grade" - show grade
    if (entryType === "Grade") {
      if (obtainedGrade) {
        const gradeDetails = getGradeDetails(obtainedGrade);
        const isPass = gradeDetails?.resultStatus === "Pass";

        return (
          <span
            style={{
              backgroundColor: isPass ? "#d4edda" : "#f8d7da",
              color: isPass ? "#155724" : "#721c24",
              padding: "4px 12px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 600,
              display: "inline-block",
            }}
          >
            {obtainedGrade}
          </span>
        );
      } else {
        return <span style={{ color: "#94a3b8", fontSize: "13px" }}>—</span>;
      }
    }

    // If entryType is "Marks" or null - show marks
    return (
      <span>
        {obtainedMarks !== null && obtainedMarks !== undefined
          ? obtainedMarks
          : 0}
        /{totalMarks || 0}
      </span>
    );
  };

  const getProfileImage = () => {
    if (student?.profilePicture) {
      return IP + student?.profilePicture.replace(/^\./, "");
    } else if (student?.gender === "M") {
      return student?.avatar_profile
        ? `/images/Boys/${student?.avatar_profile}.webp`
        : "/images/Student_boy_pic.png";
    } else if (student?.gender === "F") {
      return student?.avatar_profile
        ? `/images/Girls/${student?.avatar_profile}.webp`
        : "/images/Student_girl_pic.png";
    } else {
      return "/images/default image.png";
    }
  };

  const studentNameBlock = (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "120px",
        margin: "auto",
      }}
    >
      <img
        src={getProfileImage()}
        alt="icon"
        style={{
          width: "23px",
          height: "23px",
          marginRight: "10px",
          borderRadius: "50%",
          objectFit: "cover",
          flexShrink: 0,
        }}
        key={student?.avatar_profile}
        onError={(e) => {
          if (student?.gender === "M") {
            e.target.src = student?.avatar_profile
              ? `/images/Boys/${student?.avatar_profile}.webp`
              : "/images/Student_boy_pic.png";
          } else if (student?.gender === "F") {
            e.target.src = student?.avatar_profile
              ? `/images/Girls/${student?.avatar_profile}.webp`
              : "/images/Student_girl_pic.png";
          } else {
            e.target.src = "/images/default image.png";
          }
        }}
      />
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textAlign: "left",
          flexGrow: 1,
        }}
      >
        {student?.name}
      </span>
    </span>
  );

  return (
    <tr style={{ borderBottom: "1px solid #D9D9D9" }}>
      <td style={{ textAlign: "start" }}>
        {isCompleted ? (
          <Link
            to="/QuestionnoboxCompletedActivity"
            className="link"
            state={{
              completeActivity_id: completeActivity_id,
              student_id: student_id,
              entryType: entryType,
              obtainedGrade: obtainedGrade,
              gradeScaleId: gradeScaleId,
            }}
          >
            {studentNameBlock}
          </Link>
        ) : (
          studentNameBlock
        )}
      </td>
      <td>{student?.roll_number}</td>
      <td>{completeActivitys?.standard_id?.name}</td>
      <td>{completeActivitys?.section_id?.name}</td>
      <td style={{ textAlign: "center" }}>
        {completeSLData?.status === "pending"
          ? "Not Submitted"
          : moment(completeSLData?.submitted_on).format("DD/MM/YYYY")}
      </td>

      {/* 🔥 Updated Marks/Grade Column */}
      <td>{renderMarksOrGrade()}</td>

      <td className="text-capitalize">{completeSLData?.status}</td>
    </tr>
  );
};

export default StudentTableActivityCompleted;
